import { render } from "./SlideHeroComponent.vue?vue&type=template&id=4350b26e"
import script from "./SlideHeroComponent.vue?vue&type=script&lang=js"
export * from "./SlideHeroComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__